//@flow
import React from 'react';
import {Link} from 'react-router';

type Props = {};

const title = "Sorry, we couldn't find that product.";
const linkText = "View all items and keep shopping.";
const linkUrl = "/products";


export default function NotFound(props:Props) {
  return (
    <div className="not-found">
      <div className="content">
        <div className="banner-image" />
        <h1 className="title">
          {title}
        </h1>
        <Link className="link" to={linkUrl}>
          {linkText}
        </Link>
      </div>
      <div className="footer-banner-image" />
    </div>
  );
}
